export default __webpack_public_path__ + "static/cpgherosvg-235e089176bb7b063f46e503bda9390e.svg";